module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av338-5dbe22c8a42be38854c8a1ceeb5c5d7f.jpg";